import React from 'react';
import PreserveFormatting from 'components/shared/PreserveFormatting';
import { useFeatureFlags } from 'components/shared/hooks';
import MediaPlayer from 'components/ui/MediaPlayer';

const AttemptPreview = ({
  attempt,
  ziggeoApiKey,
  attemptHeader = t('practice.practice_feedback.request_feedback.your_attempt'),
}) => {
  const hasZiggeoForAllMedia = useFeatureFlags(['ziggeo_for_all_media']);
  switch (attempt.scenarioType) {
    case 'webcam_recording':
    case 'screen_recording':
    case 'audio_recording':
      return (
        <MediaPlayer
          recording={attempt.recording}
          ziggeoApiKey={ziggeoApiKey}
          hasZiggeoForAllMedia={hasZiggeoForAllMedia}
          customClass="pos-r iframe-16-9"
        />
      );
    case 'written_response':
      return (
        <>
          <strong className="d-ib mb-8">{attemptHeader}</strong>
          <p className="m-0 p-12 fz-base mh-40 bdrs-base bd-gray-lighter text-wrap">
            <PreserveFormatting>{attempt.answer}</PreserveFormatting>
          </p>
        </>
      );
    default:
      return <div />;
  }
};

export default AttemptPreview;
